import React from 'react';
import { Stethoscope } from 'lucide-react';
import { SPECIALTIES_OPTIONS, LANGUAGES_OPTIONS, SUB_SPECIALIZATION_OPTIONS } from '../register/options';

export const RegisterDoctorProfessionalInfo = ({ formData, handleChange, renderTagSelector }) => (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Stethoscope className="w-5 h-5 text-[hsl(var(--primary))]" />
        Professional Information
      </h3>
      
      <div>
        <label className="block text-sm font-medium mb-1.5">Primary Specialization *</label>
        <select
          name="specialization"
          value={formData.specialization}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          required
        >
          <option value="">Select Specialization</option>
          {SPECIALTIES_OPTIONS.map(spec => (
            <option key={spec} value={spec}>{spec}</option>
          ))}
        </select>
      </div>

      {formData.specialization && (
        <div>
          {renderTagSelector(
            'sub_specializations', 
            SUB_SPECIALIZATION_OPTIONS[formData.specialization] || SUB_SPECIALIZATION_OPTIONS['default'],
            'Sub-Specializations'
          )}
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">Experience (Years) *</label>
          <input
            name="experience_years"
            type="number"
            value={formData.experience_years}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="15"
            min="0"
            max="60"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Consultation Fee (INR)</label>
          <input
            name="consultation_fee"
            type="number"
            value={formData.consultation_fee}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="2000"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">City *</label>
          <input
            name="city"
            type="text"
            value={formData.city}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="Mumbai"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">State *</label>
          <input
            name="state"
            type="text"
            value={formData.state}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="Maharashtra"
            required
          />
        </div>
      </div>

      {renderTagSelector('languages', LANGUAGES_OPTIONS, 'Languages Spoken')}
    </div>
);
